module.exports = __webpack_public_path__ + "static/epitome-venti2-selected-1a3b48703d664b6da8a97c62118f41a3.png";